import React from 'react';
interface ReportStatCardProps {
  label: string;
  value: string | number;
  sub?: string;
  color?: 'blue' | 'green' | 'amber' | 'purple' | 'indigo' | 'red';
  icon?: React.ReactNode;
}
const COLORS = {
  blue: { bg: 'bg-[var(--slate-dim)]', val: 'text-[var(--text-sec)]', sub: 'text-[var(--text-sec)]' },
  green: { bg: 'bg-[var(--green-dim)]', val: 'text-[var(--green)] dark:text-[var(--text-ter)]', sub: 'text-[var(--green)] dark:text-[var(--text-ter)]' },
  amber: { bg: 'bg-[var(--mustard-dim)]', val: 'text-[var(--mustard)]', sub: 'text-[var(--mustard)]' },
  purple: { bg: 'bg-[var(--slate-dim)]', val: 'text-[var(--text-sec)]', sub: 'text-[var(--text-sec)]' },
  indigo: { bg: 'bg-[var(--slate-dim)]', val: 'text-[var(--text-sec)]', sub: 'text-[var(--text-sec)]' },
  red: { bg: 'bg-[var(--coral-dim)]', val: 'text-[var(--coral)]', sub: 'text-[var(--coral)]' },
};
export function ReportStatCard({ label, value, sub, color = 'indigo', icon }: ReportStatCardProps) {
  const c = COLORS[color];
  return (
    <div className={`${c.bg}  p-5`}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold text-[var(--text-sec)] uppercase tracking-wider mb-1">{label}</p>
          <p className={`text-3xl leading-none tabular-nums ${c.val}`} style={{ fontFamily: 'var(--serif)' }}>{value}</p>
          {sub && <p className={`text-xs mt-1 ${c.sub}`}>{sub}</p>}
        </div>
        {icon && <div className={`${c.val} opacity-60`}>{icon}</div>}
      </div>
    </div>
  );
}
